import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { TextField } from "@mui/material";
import * as yup from "yup";
import { useState } from "react";
import { HashLoader } from "react-spinners";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";

import { MainButton } from "../../components/MainButton";
import { COLORS } from "../../utils/colors";
import { getOrgByEmail } from "../../api/user";
import { setSession, updateUser } from "../../store/mainReducer";

const validationSchema = yup.object({
  email: yup
    .string("Enter your email")
    .email("Enter a valid email")
    .required("Email is required"),
  password: yup
    .string("Enter your password")
    .min(8, "Password should be of minimum 8 characters length")
    .required("Password is required"),
});

function Login({ handleScreenChange, supabaseClient }) {
  const [loading, setLoading] = useState(false);
  const [errMessage, setErrMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();

  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);

  const handleFormSubmit = async (values) => {
    if (loading) return;

    try {
      console.log("Logging in...");

      setErrMessage("");

      setLoading(true);

      const { data, error } = await supabaseClient.auth.signInWithPassword({
        email: values.email,
        password: values.password,
      });

      setLoading(false);

      if (error) {
        setErrMessage(`${error}`);
      }

      if (data.session) {
        dispatch(setSession(data.session));

        const user = await getOrgByEmail(data.user.email);
        /**
         * Populating the user data in the redux store
         */
        dispatch(updateUser(user.data));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => handleFormSubmit(values),
  });

  return (
    <div className="auth-container">
      <p className="auth-header" style={{ fontWeight: "800" }}>
        Log in to OOVAL
      </p>
      <p
        id="subheader"
        style={{ margin: "10px 0px 30px", alignSelf: "center" }}
      >
        Enter your email below to log into your account
      </p>
      <br />
      <form className="login-form" onSubmit={formik.handleSubmit}>
        <p id="subheaderBlack" style={{ marginBottom: "3px" }}>
          Your email address
        </p>
        <TextField
          fullWidth
          size="small"
          className="input"
          id="email"
          name="email"
          placeholder="richard.hendriks@hooli.com"
          value={formik.values.email}
          onChange={formik.handleChange}
          error={formik.touched.email && Boolean(formik.errors.email)}
          helperText={formik.touched.email && formik.errors.email}
          sx={{
            "& label": { paddingLeft: (theme) => theme.spacing(1) },
            "& fieldset": {
              borderRadius: "6px",
              border: `2px solid #f0f1f5`,
              transition: ".2s ease-in-out all",
            },
          }}
        />
        <p id="subheaderBlack" style={{ marginBottom: "3px" }}>
          Your password
        </p>
        <TextField
          fullWidth
          size="small"
          className="input"
          id="password"
          name="password"
          placeholder="****************"
          type={showPassword ? "text" : "password"}
          value={formik.values.password}
          onChange={formik.handleChange}
          error={formik.touched.password && Boolean(formik.errors.password)}
          helperText={formik.touched.password && formik.errors.password}
          sx={{
            "& label": { paddingLeft: (theme) => theme.spacing(1) },
            "& fieldset": {
              borderRadius: "6px",
              border: `2px solid #f0f1f5`,
              transition: ".2s ease-in-out all",
            },
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  // aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                >
                  {showPassword ? (
                    <AiFillEyeInvisible size={20} color={COLORS.lightGrey} />
                  ) : (
                    <AiFillEye size={20} />
                  )}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        {errMessage && <p className="error-message">{errMessage}</p>}
        <div style={{ height: "9px" }} />
        <MainButton
          type="submit"
          disabled={loading}
          text={
            loading ? (
              <>
                <HashLoader size={20} color={COLORS.grey} /> Continue
              </>
            ) : (
              "Continue"
            )
          }
          color={COLORS.black}
          textColor={COLORS.white}
          textHoverColor={COLORS.white}
          hoverColor={COLORS.mainAccent}
          shadowColor={"transparent"}
          onClickAction={() => formik.handleSubmit()}
        />
        <br />
        <br />
        <br />
        <div
          className="container-row"
          style={{ width: "100%", justifyContent: "space-between" }}
        >
          <p
            className="bottom-link"
            onClick={() => handleScreenChange("reset")}
          >
            Forgot password?
          </p>
          <p
            className="bottom-link"
            style={{ cursor: "pointer" }}
            onClick={() => handleScreenChange("register")}
          >
            Create account
          </p>
        </div>
      </form>
    </div>
  );
}

export default Login;
